import { RelocationStatus } from "@/gql/graphql";
import { FC } from "react";
import {
  ArchiveBoxIcon,
  CubeTransparentIcon,
} from "@heroicons/react/24/outline";
import { TagsIcon, TimerOffIcon } from "lucide-react";
import { PauseIcon, PlayIcon } from "@heroicons/react/20/solid";
import { ButtonColor } from "@/components/catalyst/button";
import { useTranslations } from "use-intl";

export function useGetRelocationStatusMap(): {
  [key in RelocationStatus]: {
    label: string;
    color: string;
    buttonColor: ButtonColor;
    Icon: FC<any>;
    transitions: RelocationStatus[];
  };
} {
  const t = useTranslations("relocation");

  return {
    [RelocationStatus.Archived]: {
      label: t("statusLabels.ARCHIVED"),
      color: "text-purple-500",
      buttonColor: "purple",
      Icon: ArchiveBoxIcon,
      transitions: [],
    },
    [RelocationStatus.Draft]: {
      label: t("statusLabels.DRAFT"),
      color: "text-gray-500",
      buttonColor: "zinc",
      Icon: CubeTransparentIcon,
      transitions: [RelocationStatus.Ready, RelocationStatus.Archived],
    },
    [RelocationStatus.Expired]: {
      label: t("statusLabels.EXPIRED"),
      color: "text-red-500",
      buttonColor: "red",
      Icon: TimerOffIcon,
      transitions: [RelocationStatus.Ready, RelocationStatus.Archived],
    },
    [RelocationStatus.Ready]: {
      label: t("statusLabels.READY"),
      color: "text-green-500",
      buttonColor: "green",
      Icon: PlayIcon,
      transitions: [RelocationStatus.Paused, RelocationStatus.Archived],
    },
    [RelocationStatus.Paused]: {
      label: t("statusLabels.PAUSED"),
      color: "text-gray-500",
      buttonColor: "zinc",
      Icon: PauseIcon,
      transitions: [RelocationStatus.Ready, RelocationStatus.Archived],
    },
    [RelocationStatus.SoldOut]: {
      label: t("statusLabels.SOLD_OUT"),
      color: "text-yellow-500",
      buttonColor: "yellow",
      Icon: TagsIcon,
      transitions: [RelocationStatus.Ready, RelocationStatus.Archived],
    },
  };
}

export const relocationStatusMap: {
  [key in RelocationStatus]: {
    label: string;
    color: string;
    buttonColor: ButtonColor;
    Icon: FC<any>;
    transitions: RelocationStatus[];
  };
} = {
  [RelocationStatus.Archived]: {
    label: "Archived",
    color: "text-purple-500",
    buttonColor: "purple",
    Icon: ArchiveBoxIcon,
    transitions: [],
  },
  [RelocationStatus.Draft]: {
    label: "Draft",
    color: "text-gray-500",
    buttonColor: "zinc",
    Icon: CubeTransparentIcon,
    transitions: [RelocationStatus.Ready, RelocationStatus.Archived],
  },
  [RelocationStatus.Expired]: {
    label: "Expired",
    color: "text-red-500",
    buttonColor: "red",
    Icon: TimerOffIcon,
    transitions: [RelocationStatus.Ready, RelocationStatus.Archived],
  },
  [RelocationStatus.Ready]: {
    label: "Active",
    color: "text-green-500",
    buttonColor: "green",
    Icon: PlayIcon,
    transitions: [RelocationStatus.Paused, RelocationStatus.Archived],
  },
  [RelocationStatus.Paused]: {
    label: "Paused",
    color: "text-gray-500",
    buttonColor: "zinc",
    Icon: PauseIcon,
    transitions: [RelocationStatus.Ready, RelocationStatus.Archived],
  },
  [RelocationStatus.SoldOut]: {
    label: "Sold out",
    color: "text-yellow-500",
    buttonColor: "yellow",
    Icon: TagsIcon,
    transitions: [RelocationStatus.Ready, RelocationStatus.Archived],
  },
};
